import $api from "../http";
import { AxiosResponse } from "axios";

export default class AsteriskService {

    static async getQueueStatus() {
        return $api.get(`/asterisk/queue/status`)
    }

    static async putQueueStatus(queue_status) {
        return $api.put(`/asterisk/queue/status`, {queue_status})
    }

}